<template>
  <div class="space-y-2">
    <button
      type="button"
      @click="settingsCollapsed = !settingsCollapsed"
      class="w-full flex items-center justify-between text-left hover:bg-gray-50 dark:hover:bg-gray-800 rounded p-1 transition-colors"
    >
      <span class="text-xs font-medium text-gray-700 dark:text-gray-300">Rota Ayarları</span>
      <i
        class="fas text-xs text-gray-400 transition-transform"
        :class="settingsCollapsed ? 'fa-chevron-right' : 'fa-chevron-down'"
      ></i>
    </button>

    <div v-show="!settingsCollapsed" class="space-y-2">
      <!-- Route Type -->
      <div>
        <label class="block text-xs text-gray-500 dark:text-gray-400 mb-1">Rota Türü</label>
        <select
          :value="String(routeType)"
          @input="$emit('update:routeType', Number($event.target.value))"
          class="w-full text-xs border border-gray-300 dark:border-gray-600 px-2 py-1.5 rounded bg-white dark:bg-gray-800 text-gray-900 dark:text-white focus:ring-1 focus:ring-blue-500 focus:border-blue-500"
        >
          <option value="1">En Hızlı</option>
          <option value="2">En Kısa</option>
        </select>
      </div>

      <!-- Vehicle Type -->
      <div>
        <label class="block text-xs text-gray-500 dark:text-gray-400 mb-1">Araç Türü</label>
        <div v-if="vehicleTypes && vehicleTypes.length > 0">
          <select
            :value="selectedVehicleTypeId"
            @change="$emit('update:vehicleTypeId', Number($event.target.value))"
            class="w-full text-xs border border-gray-300 dark:border-gray-600 px-2 py-1.5 rounded bg-white dark:bg-gray-800 text-gray-900 dark:text-white focus:ring-1 focus:ring-blue-500 focus:border-blue-500"
          >
            <option
              v-for="item in vehicleTypes"
              :key="item.id"
              :value="String(item.id)"
            >
              {{ item.name }}
            </option>
          </select>
        </div>
        <div v-else class="text-xs text-gray-400">Yükleniyor...</div>
      </div>

      <!-- Toll Roads -->
      <div>
        <label class="block text-xs text-gray-500 dark:text-gray-400 mb-1">Ücretli Yollar</label>
        <select
          :value="String(isToll)"
          @input="$emit('update:isToll', Number($event.target.value))"
          class="w-full text-xs border border-gray-300 dark:border-gray-600 px-2 py-1.5 rounded bg-white dark:bg-gray-800 text-gray-900 dark:text-white focus:ring-1 focus:ring-blue-500 focus:border-blue-500"
        >
          <option value="1">Evet</option>
          <option value="0">Hayır</option>
        </select>
      </div>

      <!-- Dangerous Goods -->
      <div>
        <label class="block text-xs text-gray-500 dark:text-gray-400 mb-1">Tehlikeli Madde</label>
        <select
          :value="String(isExplosive)"
          @input="$emit('update:isExplosive', Number($event.target.value))"
          class="w-full text-xs border border-gray-300 dark:border-gray-600 px-2 py-1.5 rounded bg-white dark:bg-gray-800 text-gray-900 dark:text-white focus:ring-1 focus:ring-blue-500 focus:border-blue-500"
        >
          <option value="1">Evet</option>
          <option value="0">Hayır</option>
        </select>
      </div>

      <!-- Ship/Ferry -->
      <div>
        <label class="block text-xs text-gray-500 dark:text-gray-400 mb-1">Gemi/Feribot</label>
        <select
          :value="String(isShip)"
          @input="$emit('update:isShip', Number($event.target.value))"
          class="w-full text-xs border border-gray-300 dark:border-gray-600 px-2 py-1.5 rounded bg-white dark:bg-gray-800 text-gray-900 dark:text-white focus:ring-1 focus:ring-blue-500 focus:border-blue-500"
        >
          <option value="1">Evet</option>
          <option value="0">Hayır</option>
        </select>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'RouteSettingsPanel',
  props: {
    routeType: {
      type: Number,
      default: 1
    },
    vehicleTypeId: {
      type: Number,
      default: 5
    },
    isToll: {
      type: Number,
      default: 1
    },
    isExplosive: {
      type: Number,
      default: 0
    },
    isShip: {
      type: Number,
      default: 0
    },
    vehicleTypes: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      settingsCollapsed: false
    }
  },
  computed: {
    selectedVehicleTypeId() {
      return String(this.vehicleTypeId);
    }
  },
  emits: [
    'update:routeType',
    'update:vehicleTypeId', 
    'update:isToll',
    'update:isExplosive',
    'update:isShip',
    'update'
  ],
  watch: {
    routeType() {
      this.$emit('update');
    },
    vehicleTypeId() {
      this.$emit('update');
    },
    isToll() {
      this.$emit('update');
    },
    isExplosive() {
      this.$emit('update');
    },
    isShip() {
      this.$emit('update');
    }
  }
}
</script>